import React from 'react';

import Container from '../container';
import Header from './header';
import { ContactScreen } from './shared-components';
import { ContactContent } from './contact-content';

export interface ContactRootPageProps {
  title: string;
  subtitle: string;
  optionsTitle?: string;
  discoveryMeetingTitle?: string;
  discoveryMeetingText?: string;
  discoveryMeetings?: Record<string, any>[];
}

function ContactRootPage(props: ContactRootPageProps) {
  const { title, subtitle, optionsTitle, ...rest } = props;

  return (
    <ContactScreen>
      <Container narrow>
        <Header title={title} subtitle={subtitle} />
      </Container>
      <ContactContent {...rest} />
    </ContactScreen>
  );
}

export default ContactRootPage;
